import axiosService from '../plugins/axiosService'

export default {
    async acceuilAll(param){
        return axiosService.get('/api/acceuil/all')
    }
}
